import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
  selector: 'app-single-switch',
  templateUrl: './single-switch.component.html',
  styleUrls: ['./single-switch.component.scss'],
  imports: [ToggleSwitchModule, FormsModule],
})
export class SingleSwitchComponent implements OnInit {
  @Input()
  disabled: boolean = false;

  @Input()
  statusValue: boolean = false;

  @Input()
  classList: string = '';

  @Output() onSwitch: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  ngOnInit() {}
}
